<template>
    <div v-if="property !== 'name' && property !== 'ownerUserId'">
        <div class="label-wrapper">
            <label v-bind:for="domId">{{translate('Permission.' + property, property)}}</label>
        </div>
        <template v-if="type==='datetime-local'">
            <div class="input-group form-group c-input"
                 @keyup.enter="saveValue"
                 v-bind:class="css">
            <span class="input-group-btn">
                <button class="btn btn-default" type="button" v-on:click="undo()">
                    <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
                </button>
            </span>

                <date-pick
                        class="form-control"
                        v-bind:id="domId"
                        v-bind:ref="domId"
                        :pickTime="true"
                        v-model="computedValue"
                        :parseDate="parseDate"
                        :formatDate="formatDate"/>
                <span class="input-group-btn">
                <button class="btn btn-success" type="button" @click="saveValue">
                    &nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
                </button>
            </span>
            </div>
        </template>
        <template v-else-if="type === 'gps'">
            <div class="input-group form-group c-input"
                 v-bind:class="css">
                <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="undo()" @blur="saveValue">
                        <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"> </span>
                    </button>
                </span>
                <span class="input-group gps-wrapper">
                    <div>
                        <div class="input-group-prepend">
                            <span class="input-group-text">N</span>
                        </div>
                        <input class="form-control"
                               type="number"
                               step="0.0000001"
                               v-model="gpsLat"

                               @blur="saveValue"
                               @keyup.enter="saveValue">
                    </div>
                </span>
                <span class="input-group gps-wrapper">
                    <div>
                        <div class="input-group-prepend">
                            <span class="input-group-text">E&nbsp;</span>
                        </div>
                        <input class="form-control bottom-3px"
                           type="number"
                           step="0.0000001"
                           v-model="gpsLon"

                           @blur="saveValue"
                           @keyup.enter="saveValue">
                    </div>
                </span>
                <span class="input-group-btn">
                    <button class="btn btn-success" type="button">
                        &nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
                    </button>
                </span>
            </div>
        </template>
        <template v-else>
            <div class="input-group form-group c-input"
                 v-bind:class="css">
                <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="undo()">
                        <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
                    </button>
                </span>
                <input class="form-control"
                       v-bind:type="type"
                       v-bind:id="domId"
                       v-bind:ref="domId"
                       v-model="computedValue"
                       @blur="saveValue"
                       @keyup.enter="saveValue">
                <span class="input-group-btn">
                    <button class="btn btn-success" type="button" @click="saveValue">
                        &nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
                    </button>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import DatePick from 'vue-date-pick';
    import 'vue-date-pick/dist/vueDatePick.css';
    import moment from 'moment';

    const dateTimeFormat =  moment.HTML5_FMT.DATETIME_LOCAL;

    export default {
        name: "simulationPropertyInput",
        components: {DatePick},
        data: function () {
            return {
                change: null,
                prevChange: null,
                css: {
                    'c-input--success': false,
                    'c-input--error': false,
                    'c-input--disable': false
                },
                changes: [],
                propertiesInMinutes: ["timePredani", "timeMisto", "timeStaticRouteTime", "timeTransition", "timeVyzva"]
            }
        },
        props: {
            domId: {
                type: String,
                required: true
            },
            value: {
                required: true
            },
            property: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            simId: {
                type: Number,
                required: true
            }
        },
        methods: {
            parseDate(dateString){
                return moment(dateString, dateTimeFormat).toDate();
            },
            formatDate(dateObj) {
                return moment(dateObj).format(dateTimeFormat);
            },
            async saveValue() {
                if (this.computedValue != this.prevValue) {  // used != instead of !== because some values at the beginning are strings (Map zoom)
                    // Deep check for gps array as above check (!=) wouldn't work
                    if (this.type === "gps" && (this.computedValue[0] === this.prevValue[0] && this.computedValue[1] === this.prevValue[1])) {
                        return;
                    } else {
                        this.prevValue = this.computedValue;
                    }

                    this.changes.push(this.computedValue);
                    this.disable();
                    let {simId, property, computedValue: value} = this;
                    if (this.type === 'number') {
                        value = Number(this.minToMillis(value));
                    }
                    try {
                        await this.$store.dispatch('callApi', {
                            name: 'setSimulationProperty',
                            payload: {simId, property, value}
                        });
                        this.success();
                        setTimeout(this.clear, 800);
                    } catch (e) {
                        console.error(e);
                        this.error();
                        setTimeout(this.clear, 800);
                    }
                    this.$emit('reload');
                }

            },

            disable() {
                this.$set(this.css, 'c-input--disable', true);
                this.$set(this.css, 'c-input--success', false);
                this.$set(this.css, 'c-input--error', false);
            },
            success() {
                this.$set(this.css, 'c-input--disable', false);
                this.$set(this.css, 'c-input--success', true);
                this.$set(this.css, 'c-input--error', false);
            },
            error() {
                this.$set(this.css, 'c-input--disable', false);
                this.$set(this.css, 'c-input--success', false);
                this.$set(this.css, 'c-input--error', true);

            },
            clear() {
                this.$set(this.css, 'c-input--disable', false);
                this.$set(this.css, 'c-input--success', false);
                this.$set(this.css, 'c-input--error', false);
                this.change = null;

            },
            undo() {
                if (this.changes.length > 1) {
                    this.changes.pop();
                    this.change = this.changes[this.changes.length - 1];
                } else if (!this.changes.length) {
                    this.change = null;
                }
                this.$refs[this.domId].focus();
            },
            millisToMin(val) {
                if(this.$props.type === "number" && this.propertiesInMinutes.includes(this.$props.property)) {
                    // check if greater than 1000
                    if (val >= 1000) {
                        return (val/60000).toFixed(3);
                    } else {
                        return val;
                    }
                } else {
                    return val;
                }
            },
            minToMillis(val) {
                if(this.$props.type === "number" && this.propertiesInMinutes.includes(this.$props.property)) {
                    return val*60000;
                } else {
                    return val;
                }
            },
            ...mapActions(['sendCommand'])
        },
        mounted() {
            this.uniq_id = 'form_' + this._uid;
            this.changes.push(this.computedValue);
            this.prevValue = this.computedValue;
            if (this.isScenarioChange) {
                this.$set(this.css, 'c-input--scenario-val', true);
            }
        },
        computed: {
            computedValue: {
                get() {
                    if (this.change === null) {
                        return this.millisToMin(this.$props.value);
                    } else {
                        return this.millisToMin(this.change);
                    }
                },
                set(value) {
                    this.change = value;

                },
            },
            prevValue: {
                get() {
                    return this.prevChange;
                },
                set(value) {
                    this.prevChange = value;
                }
            },
            extension() {
                return this.$store.getters.getPropertyExtension(this.dataEntityId, this.dataProperty) || {};
            },
            isEditorMode() {
                return this.$store.state.editMode;
            },
            isScenarioChange() {
                return this.isEditorMode && this.$store.getters.isPropertyScenarioChange(this.dataEntityId, this.dataProperty);
            },
            gpsLat: {
                get() {
                    if (Array.isArray(this.value)) {
                        return this.value[0];
                    } else {
                        return undefined;
                    }
                },
                set(value) {
                    if (Array.isArray(this.value)) {
                        this.value[0] =  Number(value);
                    } else {
                        this.value = [ Number(value), 0];
                    }
                }

            },
            gpsLon: {
                get() {
                    if (Array.isArray(this.value)) {
                        return this.value[1];
                    } else {
                        return undefined;
                    }
                },
                set(value) {
                    if (Array.isArray(this.value)) {
                        this.value[1] = Number(value);
                    } else {
                        this.value = [0 , Number(value)];
                    }
                }

            },
        },

    }
</script>

<style scoped>
    .label-wrapper label { padding-left: 39px; }
    .gps-wrapper div {width: 100%; display: inline-flex;}
    .gps-wrapper div div.input-group-prepend { width: auto;}
    .input-group-prepend span {font-size: 1.0625em; height: 34px; width: 30px; border-top-right-radius: 0; border-bottom-right-radius: 0;}
    .c-form .form-control { padding: 5px; margin-top: 1px; margin-bottom: 1px;}
    /*.gps-wrapper div.input-group-prepend {margin: 1px -1px 1px 0;}*/
    .c-input select {margin-left: 39px}
</style>
